import { api } from "services/api";
import { GetProjectArgs, GetProjectByTagIdsArgs, ProjectResult, ProjectSlug } from "./typing";
import { transformProjectResult } from "./transformers";
import { generateParams } from "utils/urlConversion";


export interface ProjectRequest {
  project: any;
  passkey: string;
};


const projectApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getProjectById: builder.query<ProjectResult, GetProjectArgs>({
      query: (args) => {
        return `/project/${args.id}`;
      },
      transformResponse(result: ProjectResult, meta, args) {
        return transformProjectResult(result);
      }
    }),

    getAllProjects: builder.query<Array<ProjectSlug>, void>({
      query: (args) => `/projects/list`
    }),

    getAllProjectIds: builder.query<Array<ProjectSlug>, GetProjectByTagIdsArgs>({
      query: (args) => `/projects/list/ids` + generateParams(args)
    }),

    getProjectsByName: builder.query<Array<ProjectSlug>, string>({
      query: (args) => {

        const params = {
          name: args,
        };


        // console.log(Object.keys(params));
        // console.log(params);
        // console.log("" + new URLSearchParams(params));


        return `/projects/search` + generateParams(params);
      }
    }),

    // This route requires token Authorization
    createProject: builder.mutation<ProjectSlug, ProjectResult>({
      query: (projectRequest) => {
        const { project, passkey } = projectRequest;

        return {
          url: `/project/${project.uid}/create` + generateParams({ passkey }),
          method: 'POST',
          body: project
        }
      },
    }),

    // This route requires token Authorization
    upateProject: builder.mutation<ProjectSlug | Partial<ProjectSlug>, ProjectResult>({
      query: (projectRequest) => {
        const { project, passkey } = projectRequest;

        return {
          url: `/project/${project.uid}/update` + generateParams({ passkey }),
          method: 'PATCH',
          body: project,
        };
      },

    }),

    // This route requires token Authorization
    removeProject: builder.mutation<string, void>({
      query: (uid) => {
        // const { passkey, uid } = projectDeleteRequest;
        return {
          url: `/project/${uid}/remove`,
          method: 'DELETE'
        }
      },

    })

  })

});



export const {
  useGetAllProjectsQuery,
  useLazyGetAllProjectsQuery,
  
  useGetAllProjectIdsQuery,
  useLazyGetAllProjectIdsQuery,

  useGetProjectByIdQuery,
  useLazyGetProjectByIdQuery,

  useGetProjectsByNameQuery,
  useLazyGetProjectsByNameQuery,

  useCreateProjectMutation,
  // useUpateProjectMutation,
  // useRemoveProjectMutation,
} = projectApi;